import {
    RELATIONSHIP_TYPES,
    type RelationshipType,
} from "./relationship-types";

// AIDEV-NOTE: User-facing labels for relationship types
export const RELATIONSHIP_LABELS: Record<RelationshipType, string> = {
    [RELATIONSHIP_TYPES.PROTECTED]: "Protected",
    [RELATIONSHIP_TYPES.PROTECTS]: "Protects",
    [RELATIONSHIP_TYPES.POLARIZED_WITH]: "Polarized With",
    [RELATIONSHIP_TYPES.ALLIED_WITH]: "Allied With",
    [RELATIONSHIP_TYPES.CONTROLS_ACCESS_TO]: "Controls Access To",
    [RELATIONSHIP_TYPES.ACCESS_MEDIATED_BY]: "Access Mediated By",
    [RELATIONSHIP_TYPES.SUPPORTS]: "Supports",
    [RELATIONSHIP_TYPES.SUPPORTED_BY]: "Supported By",
};

// Helper to get user-facing label for a relationship type
export function getRelationshipLabel(type: RelationshipType): string {
    return RELATIONSHIP_LABELS[type];
}

// AIDEV-NOTE: Descriptions for each relationship type to help users understand them
export const RELATIONSHIP_DESCRIPTIONS: Record<RelationshipType, string> = {
    [RELATIONSHIP_TYPES.PROTECTED]:
        "This part is being protected by another part",
    [RELATIONSHIP_TYPES.PROTECTS]:
        "This part protects another part from harm or vulnerability",
    [RELATIONSHIP_TYPES.POLARIZED_WITH]:
        "These parts have opposing views or are in conflict with each other",
    [RELATIONSHIP_TYPES.ALLIED_WITH]:
        "These parts work together and support similar goals",
    [RELATIONSHIP_TYPES.CONTROLS_ACCESS_TO]:
        "This part acts as a gatekeeper to another part",
    [RELATIONSHIP_TYPES.ACCESS_MEDIATED_BY]:
        "Access to this part is controlled by another part",
    [RELATIONSHIP_TYPES.SUPPORTS]:
        "This part provides support or assistance to another part",
    [RELATIONSHIP_TYPES.SUPPORTED_BY]:
        "This part receives support or assistance from another part",
};

// Get all relationship options for UI dropdowns/selects
export function getRelationshipOptions(): Array<{
    value: RelationshipType;
    label: string;
    description: string;
}> {
    return Object.values(RELATIONSHIP_TYPES).map((type) => ({
        value: type,
        label: getRelationshipLabel(type),
        description: RELATIONSHIP_DESCRIPTIONS[type],
    }));
}
